import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import useDropdownStyles from "./styles/Dropdown.js";

const Dropdown = ({
	id = "custom-dropdown",
	size = "",
	placeholder = "Placeholder",
	filled = true,
	color = "greyDark",
	background = "secondary",
	showPlaceholder = true,
	width = "",
	items = [],
	value,
	onChange,
	required = false,
	disabled = false,
}) => {
	const classes = useDropdownStyles();

	return (
		<FormControl required={required} variant="outlined" fullWidth style={{ width }}>
			<InputLabel
				id={`${id}-label`}
				sx={{
					marginTop: value ? "0.7rem" : "0rem",
					marginLeft: "-0.9rem",
					"&.Mui-focused": {
						marginTop: "0.7rem"
					},
				}}
			>{placeholder}</InputLabel>
			<Select
				id={id}
				labelId={`${id}-label`}
				disabled={disabled}
				value={value}
				displayEmpty={showPlaceholder}
				// className={classes[`${background}_${(filled ? "filled" : "outlined")}`]}
				color={background}
				size={size}
				style={{ color, height: "100%" }}
				autoWidth={!width}
				variant="standard"
				classes={{
					filled: classes[`${background}_${(filled ? "filled" : "outlined")}`],
					iconFilled: classes[`${background}_${(filled ? "filled" : "outlined")}`],
				}}
				renderValue={(selected) => items.find((item) => item.value === selected)?.text || selected || ""}
				onChange={onChange}
				sx={{
					display: "flex",
					textAlign: "left"
				}}
			>
				{items.map((it) => (
					<MenuItem key={it.text} value={it.value}>{it.text}</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default Dropdown;
